import React from 'react';
import {taxMoney} from './taxExport';

export default function TaxJurisdictionTable({rows}) {
  return <div className="tax-center__panel">
    <h2>By buyer state</h2>
    {!rows.length ? <p>No paid orders for this period and state.</p> :
      <div className="tax-center__table-scroll" role="region" aria-label="Buyer state breakdown"
        tabIndex={0}>
        <table><thead><tr><th scope="col">Buyer state</th><th scope="col">Orders</th>
          <th scope="col">Revenue</th><th scope="col">Sales tax</th>
          <th scope="col">Federal tax</th><th scope="col">Total tax</th></tr></thead>
        <tbody>{rows.map(row => <tr key={row.state || 'unknown'}>
          <th scope="row">{row.state || 'Unknown'}</th><td>{row.orderCount}</td>
          <td>{taxMoney(row.revenue)}</td><td>{taxMoney(row.salesTax)}</td>
          <td>{taxMoney(row.federalTax)}</td><td>{taxMoney(row.totalTax)}</td>
        </tr>)}</tbody></table>
      </div>}
  </div>;
}
